import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, Typography, FormControl } from "@mui/material";
import { InputLabel, MenuItem, Select, Stack, RadioGroup } from "@mui/material";
import { styled, TextField, FormControlLabel, FormLabel } from "@mui/material";
import { Radio } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getVendors } from "../vendors/vendorSlice";
import { getUnits } from "../units/unitSlice";
import { Link } from "react-router-dom";
import AddUnit from "../units/AddUnit";
import UnitsList from "../units/UnitsList";
import AddVendor from "../vendors/AddVendor";
import DialogComponent from "../reusableComponents/Dialog";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import ClipLoader from "react-spinners/ClipLoader";
import { deleteItem, updateItem } from "./itemsSlice";
import { mutateItem, remItem } from "./httpCalls";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { BoxesPacking } from "../features/BoxesPacking";
import { getLedgersNames } from "../ledgers/ledgersNamesSlice";
import Incentives from "./Incentives";
import { IncentivesFeature } from "../features/IncentivesFeature";
import AddBatchNo from "./AddBatchNo";
import ShowBatchNos from "./ShowBatchNos";
import Config from "../../utils/Config";
import S3FileUpload from "react-s3/lib/ReactS3";
import { itemNewDesign } from "../features/ItemNewDesign";

const Input = styled("div")({
  border: "1px solid #4daf51",
  padding: "10px",
  borderRadius: "10px",
  boxShadow: "0px 3px 7px #4daf51",
  // height: "70px",
});

function UpdateItem({ onClose, editItem, racks, myShops, index }) {
  let digits = localStorage.getItem("barcodeDigits");
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");

  const vendor = useSelector((state) => state.vendor);
  const units = useSelector((state) => state.units);
  const { ledgersNames } = useSelector((state) => state.ledgersNames);

  const [barcodeDigits, setBarcodeDigits] = useState(digits || 4);
  const [state, setState] = useState({
    loading: false,
    useWeight: editItem.weightType,
    ledgers: [],
    addQty: false,
    newQuantity: "",
    showUnits: false,
    unitsModal: false,
    vendorModal: false,
    deleteModal: false,
    batchModal: false,
    allBatchModal: false,
    iMeiField: false,
    editItem: {
      _id: editItem._id ?? "",
      _rev: editItem._rev ?? "",
      name: editItem.name ?? "",
      shop_code: editItem.shop_code ?? "",
      discount: editItem.discount ?? "",
      weight: editItem.weight ?? "",
      rack_code: editItem.rack_code ?? "",
      sub_rack_code: editItem.sub_rack_code ?? "",
      itemId: editItem.itemId ?? "",
      description: editItem.description ?? "",
      companyPrice: editItem.companyPrice ?? "",
      quantity: editItem.quantity ?? "",
      minQuantity: editItem.minQuantity
        ? editItem.minQuantity
        : editItem.minquantity
        ? editItem.minquantity
        : 0,
      itemCode: editItem.itemCode ?? "",
      price: editItem.price ?? "",
      costPrice: editItem.costPrice ?? "",
      vendor: editItem.vendor ?? "",
      weightType: editItem.weightType ?? "",
      unit: editItem.unit ?? "",
      barCode: editItem.barCode ?? "",
      whole_sale_price: editItem.whole_sale_price ?? "",
      ledger: editItem.ledger ?? "",
      vendor: editItem.vendor ?? "",
      shop_stock: editItem.shop_stock ?? "",
      batchNumber: editItem.batchNumber ?? [],
      expiryDate: editItem.expiryDate ?? "",
      boxes: editItem.boxes ?? "",
      packing: editItem.packing ?? "",
      imgURL: editItem.imgURL ?? "",
      box: editItem.box ?? "",
      piecesPerBox: editItem.piecesPerBox ?? "",
      pricePerPiece: editItem.pricePerPiece ?? "",
      imeiNumber: editItem?.imeiNumber ?? "",
      saleLabel: "",
      steelWeightTotal: "",
      steelWeightKg: "",
      expiryDate: "",

    },
  });
  console.log("  state.newQuantity", state.newQuantity);
  console.log("  stateeeeeee", state);

  console.log("edit", state.editItem);
  console.log("editProp", editItem);
  console.log("steelweightTotal", state.editItem.steelWeightTotal);
  console.log("saleLabel", state.editItem.saleLabel);
  const [itemImg, setItemImg] = useState(null);

  useEffect(() => {
    if (vendor.vendors == "") {
      dispatch(getVendors());
    }
    if (units.units == "") {
      dispatch(getUnits());
    }

    if (ledgersNames.length == 0) {
      dispatch(getLedgersNames());
    }
  }, []);

  const pricePerBoxHandler = () => {
    const pricePerBox =
      Number(state.editItem.price) / Number(state.editItem.piecesPerBox);
    console.log("priceperbox", pricePerBox);
    return pricePerBox;
  };

  useEffect(() => {
    const steelWeightCalculator = () => {
      let result =
        (state?.editItem?.steelWeightKg || editItem.steelWeightKg) *
          (state?.editItem?.quantity || editItem.quantity) ||
        editItem.steelWeightTotal;
      setState((pre) => ({
        ...pre,
        editItem: { ...pre.editItem, steelWeightTotal: result },
      }));
      console.log("result", result);

      return result;
    };
    steelWeightCalculator();
  }, [state?.editItem?.steelWeightKg, state?.editItem?.quantity]);

  const handleWeight = (e) => {
    const { name } = e.target;

    let value = e.target.checked;
    let quantity = 0;
    let weight = 0;
    if (value == true) {
      weight = state.editItem.quantity ? state.editItem.quantity : 0;
    } else {
      quantity = state.editItem.weight ? state.editItem.weight : 0;
    }

    if (name == "useImei") {
      setState((pre) => ({
        ...pre,
        iMeiField: !state.iMeiField,
        // useWeight: !pre.useWeight,
      }));
    } else {
      setState((pre) => ({
        ...pre,
        editItem: { ...pre.editItem, weightType: value, quantity, weight },
      }));
    }
  };
  const handleInput = (e) => {
    let { name, value } = e.target;
    console.log("nameeee", name);
    console.log("valueeeeeee", value);
    // const pricePerBox = Number(state.editItem.price) / Number(state.editItem.piecesPerBox);
    if (name == "price" && state.editItem.piecesPerBox) {
      const pricePerBox = Number(value) / Number(state.editItem.piecesPerBox);
      setState((pre) => ({
        ...pre,
        editItem: {
          ...pre.editItem,
          [name]: value,
          pricePerPiece: pricePerBox,
        },
      }));
    } else if (name == "piecesPerBox" && state.editItem.piecesPerBox) {
      const pricePerBox = Number(state.editItem.price) / Number(value);
      setState((pre) => ({
        ...pre,
        editItem: {
          ...pre.editItem,
          [name]: value,
          pricePerPiece: pricePerBox,
        },
      }));
    } else if (name == "expiryDate" ) {
      setState((pre) => ({
        ...pre,
        editItem: {
          ...pre.editItem,
          [name]: value,
        },
      }));
    } else {
      setState((pre) => ({
        ...pre,
        editItem: { ...pre.editItem, [name]: value },
      }));
    }
  };

  const handleImage = (e) => {
    if (e.target.files.length > 0) {
      setItemImg(e.target.files[0]);
    } else {
      setItemImg(null);
    }
  };

  const handleItemId = (e) => {
    handleInput(e);
  };
  const toggle = (name) => {
    setState((pre) => ({ ...pre, [name]: !pre[name] }));
  };

  const handleDelete = async () => {
    onClose();
    dispatch(deleteItem({ index: index }));
    remItem(state.editItem._id, index, editItem);
  };

  const handleUpdate = async () => {
    onClose();
    if (itemImg) {
      let url = await S3FileUpload.uploadFile(itemImg, Config());
      dispatch(updateItem({ ...state.editItem, imgURL: url.location }));
      mutateItem(
        index,
        { ...state.editItem, imgURL: url.location },
        editItem,
        dispatch
      );
    } else {
      dispatch(updateItem(state.editItem));
      mutateItem(index, state.editItem, editItem, dispatch);
    }
  };

  const handleAdd = () => {
    setState((prev) => ({ ...prev, addQty: !prev.addQty }));
  };
  const handleNewQty = (e) => {
    const { value } = e.target;
    console.log("value", value);
    setState((prev) => ({ ...prev, newQuantity: value }));
  };

  const addMoreQty = () => {
    let copy = JSON.parse(JSON.stringify(state.editItem));
    console.log("state", state.editItem);
    console.log("copy", copy);

    if (copy?.weightType) {
      copy.weight = parseFloat(copy.weight) + parseFloat(state.newQuantity);
    } else {
      copy.quantity = Number(copy.quantity) + parseFloat(state.newQuantity);
    }
    console.log("copyyy", copy);
    setState((prev) => ({ ...prev, addQty: false }));
    onClose();
    dispatch(updateItem(copy));
    mutateItem(index, copy, editItem, dispatch);
  };

  const handleBatch = (e) => {
    setState((prev) => ({
      ...prev,
      batchModal: false,
      editItem: {
        ...prev.editItem,
        batchNumber: [...prev.editItem.batchNumber, e],
      },
    }));
  };

  const handleUpdateBatch = (e) => {
    let oldQty = state.editItem.batchNumber.reduce((acc, item) => {
      acc += parseInt(item.quantity);
      return acc;
    }, 0);
    let newQty = e.reduce((acc, item) => {
      acc += parseInt(item.quantity);
      return acc;
    }, 0);
    let final = oldQty - newQty;
    setState((prev) => ({
      ...prev,
      allBatchModal: false,
      editItem: {
        ...prev.editItem,
        quantity: prev.editItem.quantity - final,
        batchNumber: e,
      },
    }));
  };

  const handleWarehouse = (e) => {
    const { value } = e.target;
    let found = myShops.find((i) => i.shopName == value);
    if (found) {
      setState((pre) => ({
        ...pre,
        editItem: {
          ...pre.editItem,
          shop_code: {
            shopName: found.shopName,
            shop_code: found.shop_code,
          },
        },
      }));
    }
  };

  const handleGenerateBarcode = () => {
    let randomBarcode;
    if (barcodeDigits == 4) {
      randomBarcode = Math.floor(Math.random() * 9000) + 1000;
    } else {
      randomBarcode =
        Math.floor(Math.random() * 90000000000000) + 10000000000000;
    }
    setState((pre) => ({
      ...pre,
      editItem: { ...pre.editItem, barCode: randomBarcode.toString() },
    }));
  };

  const handleBarcode = (e) => {
    const { value } = e.target;
    setBarcodeDigits(value);
    localStorage.setItem("barcodeDigits", value);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2, color: "#4EAF51" }}>
        Update Item Now!
      </Typography>

      <Stack spacing={2}>
        {!itemNewDesign() && (
          <Stack direction="row" spacing="16px">
            {state.editItem.imgURL && (
              <img
                height="50px"
                width="50px"
                src={state.editItem.imgURL}
                alt=""
              />
            )}
            <TextField
              fullWidth
              size="small"
              type="file"
              multiple
              variant="outlined"
              sx={{ mt: 2 }}
              onChange={handleImage}
            />
          </Stack>
        )}
        <Input>
          <TextField
            variant="standard"
            value={state.editItem.name}
            required
            autoFocus
            name="name"
            label="Name"
            type="text"
            fullWidth
            InputProps={{ disableUnderline: true }}
            onChange={handleInput}
          />
        </Input>
        <Input>
          <TextField
            variant="standard"
            name="description"
            label="Description"
            type="text"
            fullWidth
            InputProps={{ disableUnderline: true }}
            value={state.editItem.description}
            onChange={handleInput}
          />
        </Input>
        {itemNewDesign() && (
          <>
            <Input>
              <TextField
                variant="standard"
                name="material"
                label="Material"
                type="text"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.editItem.material || editItem?.material || ""}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                name="carModel"
                label="Car/Model"
                type="text"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.editItem.carModel || editItem?.carModel || ""}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                name="color"
                label="Colour"
                type="text"
                fullWidth
                InputProps={{ disableUnderline: true }}
                value={state.editItem.color || editItem.color || ""}
                onChange={handleInput}
              />
            </Input>
          </>
        )}
        {!itemNewDesign() && (
          <Input>
            {units.loading && (
              <ClipLoader size={30} color={"#4DAF51"} loading={units.loading} />
            )}
            <FormControl style={{ width: "100%" }}>
              <InputLabel>
                {" "}
                {companyCode == "8553" ? "Size" : "Unit"}
              </InputLabel>
              <Select
                variant="standard"
                label="Select Unit"
                name="unit"
                onChange={handleInput}
                value={state.editItem.unit}
              >
                {units?.units.map((unit, i) => {
                  return (
                    <MenuItem key={i} value={unit}>
                      {unit}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && (
          <Stack direction="row" justifyContent="space-between">
            <Button
              size="small"
              variant="contained"
              onClick={() => toggle("showUnits")}
              style={{ color: "#ffff" }}
            >
              {companyCode == "8553" ? "Size" : "Unit"}
            </Button>
            <Button
              size="small"
              onClick={() => toggle("unitsModal")}
              style={{ color: "#4EAF51" }}
            >
              {companyCode == "8553" ? "Add Size" : " Add Unit"}
            </Button>
          </Stack>
        )}
        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Warehouse</InputLabel>
              <Select
                variant="standard"
                name="warehouse"
                onChange={handleWarehouse}
                defaultValue={editItem?.shop_code?.shopName}
              >
                {myShops.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item.shopName}>
                      {item.shopName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Racks</InputLabel>
              <Select
                variant="standard"
                name="rack_code"
                onChange={handleInput}
                value={state.editItem.rack_code}
              >
                {racks.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item._id}>
                      {item.racks.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && state.editItem.rack_code != "" && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Sub Racks</InputLabel>
              <Select
                variant="standard"
                name="sub_rack_code"
                onChange={handleInput}
                value={state.editItem?.sub_rack_code}
              >
                {racks
                  .find((its) => its._id == state.editItem.rack_code)
                  .racks.sub_rack.map((itsub, i) => {
                    return (
                      <MenuItem key={i} value={itsub}>
                        {itsub}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Ledgers</InputLabel>
              <Select
                variant="standard"
                name="ledger"
                onChange={handleInput}
                value={state.editItem.ledger}
              >
                {ledgersNames.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item._id}>
                      {item.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && (
          <Stack alignItems="flex-end">
            <Link to="/inventory/admin/ledgers" style={{ color: "#4EAF51" }}>
              Create Ledgers
            </Link>
          </Stack>
        )}
        {!itemNewDesign() && state.editItem.weightType == true && (
          <>
            <Input>
              <Stack
                direction="row"
                spacing={3}
                alignItems="center"
                justifyContent="space-between"
              >
                <TextField
                  variant="standard"
                  name="weight"
                  label="Weight in (kg)"
                  type="Number"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  value={state.editItem.weight}
                  onChange={handleInput}
                />
                <ControlPointIcon
                  sx={{ cursor: "pointer", height: "25px" }}
                  onClick={handleAdd}
                />
              </Stack>
            </Input>
            {state.addQty && (
              <Stack marginTop="10px" direction="row" spacing={3}>
                <TextField
                  variant="outlined"
                  label="Add Quantity"
                  size="small"
                  type="Number"
                  fullWidth
                  value={state.newQuantity}
                  onChange={handleNewQty}
                />
                <Button size="small" variant="contained" onClick={addMoreQty}>
                  Add
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ background: "#8e8e8e !important" }}
                  onClick={handleAdd}
                >
                  Cancel
                </Button>
              </Stack>
            )}
          </>
        )}
        {!itemNewDesign() && state.editItem.weightType != true && (
          <Stack>
            {BoxesPacking() && (
              <Stack direction="row" spacing={2} marginBottom="20px">
                <TextField
                  size="small"
                  variant="outlined"
                  value={state.editItem.boxes}
                  name="boxes"
                  label="Boxes"
                  fullWidth
                  type="number"
                  onChange={handleInput}
                />

                <TextField
                  size="small"
                  variant="outlined"
                  value={state.editItem.packing}
                  name="packing"
                  label="Packing"
                  fullWidth
                  type="number"
                  onChange={handleInput}
                />
              </Stack>
            )}
            <Stack spacing={2}>
              <Input>
                <Stack
                  direction="row"
                  spacing={3}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <TextField
                    variant="standard"
                    value={state.editItem.quantity || editItem?.quantity}
                    name="quantity"
                    label="Quantity"
                    type="Number"
                    fullWidth
                    InputProps={{ disableUnderline: true }}
                    onChange={handleInput}
                  />
                  <ControlPointIcon
                    sx={{ cursor: "pointer", height: "25px" }}
                    onClick={handleAdd}
                  />
                </Stack>
              </Input>

              {editItem?.steelWeightKg && (
                <>
                  <Input>
                    <TextField
                      variant="standard"
                      value={
                        state?.editItem?.steelWeightKg ||
                        editItem?.steelWeightKg
                      }
                      name="steelWeightKg"
                      // label="Steel Weight/Kg"
                      label="Kg Per Quantity"
                      type="Number"
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      onChange={handleInput}
                    />
                  </Input>

                  <Input>
                    <TextField
                      variant="standard"
                      value={
                        state?.editItem?.steelWeightTotal ||
                        editItem?.steelWeightTotal
                      }
                      name="steelWeightTotal"
                      label="Steel Weight/Kg"
                      type="Number"
                      fullWidth
                      InputProps={{ disableUnderline: true }}
                      //  onChange={handleInput}
                    />
                  </Input>
                </>
              )}
            </Stack>
            {state.addQty && (
              <Stack marginTop="10px" direction="row" spacing={3}>
                <TextField
                  variant="outlined"
                  label="Add Quantity"
                  size="small"
                  type="Number"
                  fullWidth
                  value={state.newQuantity}
                  onChange={handleNewQty}
                />
                <Button size="small" variant="contained" onClick={addMoreQty}>
                  Add
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  sx={{ background: "#8e8e8e !important" }}
                  onClick={handleAdd}
                >
                  Cancel
                </Button>
              </Stack>
            )}

            {state.editItem.unit == "Role" && (
              <Stack
                marginTop="15px"
                spacing={2}
                direction="row"
                justifyContent="space-between"
              >
                <TextField
                  disabled
                  variant="outlined"
                  label="Meter"
                  size="small"
                  value={parseInt(state.editItem.quantity * 100) || 0}
                  type="Number"
                  fullWidth
                  // InputProps={{ disableUnderline: true }}
                />

                <TextField
                  disabled
                  size="small"
                  variant="outlined"
                  label="RFT"
                  value={parseInt(state.editItem.quantity * 328) || 0}
                  type="Number"
                  fullWidth
                  // InputProps={{ disableUnderline: true }}
                />
              </Stack>
            )}
          </Stack>
        )}
        {itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              value={state.editItem.quantity}
              name="quantity"
              label="Stock"
              type="Number"
              fullWidth
              InputProps={{ disableUnderline: true }}
              onChange={handleInput}
            />
          </Input>
        )}
        {!itemNewDesign() && (
          <Stack alignItems="flex-end">
            <Stack direction="row">
              <FormControlLabel
                control={
                  <Checkbox
                    name="weightType"
                    checked={state.editItem.weightType}
                    onChange={handleWeight}
                  />
                }
                label="Select Weight"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="useImei"
                    checked={state.editItem.checked}
                    onChange={handleWeight}
                  />
                }
                label="Add IMEI Number"
              />
            </Stack>
          </Stack>
        )}

        {!itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              value={state.editItem.discount}
              name="discount"
              label="Discount"
              type="Number"
              fullWidth
              InputProps={{ disableUnderline: true }}
              onChange={handleInput}
            />
          </Input>
        )}

        {(state?.editItem?.imeiNumber || state.iMeiField) && (
          <Input>
            <TextField
              variant="standard"
              name="imeiNumber"
              label="Imei number"
              type="text"
              fullWidth
              InputProps={{ disableUnderline: true }}
              value={state?.editItem?.imeiNumber}
              onChange={handleInput}
            />
          </Input>
        )}
        <Input>
          <TextField
            variant="standard"
            name="minQuantity"
            label="Min Quantity"
            type="Number"
            fullWidth
            InputProps={{ disableUnderline: true }}
            value={state.editItem.minQuantity}
            onChange={handleInput}
          />
        </Input>
        {!itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              name="itemId"
              label="Item Code"
              type="text"
              fullWidth
              value={state.editItem.itemId}
              InputProps={{ disableUnderline: true }}
              onChange={handleItemId}
            />
          </Input>
        )}
        <Input>
          <TextField
            variant="standard"
            label="Bar Code"
            type="number"
            name="barCode"
            value={state.editItem.barCode}
            fullWidth
            InputProps={{ disableUnderline: true }}
            onChange={handleInput}
          />
        </Input>
        <Stack
          direction="row"
          alignItems="start"
          justifyContent="space-between"
        >
          <FormControl>
            <FormLabel>Digits</FormLabel>
            <RadioGroup row value={barcodeDigits} onChange={handleBarcode}>
              <FormControlLabel
                value={4}
                control={<Radio disableRipple />}
                label="4"
              />
              <FormControlLabel
                value={14}
                control={<Radio disableRipple />}
                label="14"
              />
            </RadioGroup>
          </FormControl>
          <Button
            variant="contained"
            size="small"
            sx={{ textTransform: "none" }}
            onClick={handleGenerateBarcode}
          >
            {state.editItem.barCode ? "Update Barcode" : "Generate Barcode"}
          </Button>
        </Stack>
        {itemNewDesign() && (
          <Stack direction="row" justifyContent="space-between">
            <Input>
              <TextField
                variant="standard"
                value={state.editItem.price}
                name="price"
                label="Sale Price"
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                name="costPrice"
                label={
                  state.editItem.box === true &&
                  (state?.editItem?.saleLabel || editItem?.saleLabel) === "ctn"
                    ? "Cost Price Per Ctn"
                    : "Cost Price"
                }
                value={state.editItem.costPrice}
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}
        {!itemNewDesign() && (
          <Stack direction="row" justifyContent="space-between">
            <Input>
              <TextField
                variant="standard"
                name="costPrice"
                label={
                  state.editItem.box == true &&
                  (state?.editItem?.saleLabel || editItem?.saleLabel) === "ctn"
                    ? " Cost Price Per Ctn"
                    : "Cost Price"
                }
                value={state.editItem.costPrice}
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                value={state.editItem.price}
                name="price"
                label={
                  state.editItem.box == true &&
                  (state?.editItem?.saleLabel || editItem?.saleLabel) === "ctn"
                    ? " Sale Price Per Box"
                    : "Sale Price"
                }
                type="Number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}
        {!itemNewDesign() && state.editItem.box !== true && (
          <Stack direction="row" justifyContent="space-between">
            <Input>
              <TextField
                variant="standard"
                name="companyPrice"
                label="Company Price"
                type="Number"
                value={state.editItem.companyPrice}
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                min="1"
                label="Whole Sale Price"
                name="whole_sale_price"
                value={state.editItem.whole_sale_price}
                type="number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}

        {!itemNewDesign() && state.editItem.box == true && (
          <Stack direction="row" justifyContent="space-between">
            <Input>
              <TextField
                variant="standard"
                name="piecesPerBox"
                label={
                  state.editItem.box == true &&
                  (state?.editItem?.saleLabel || editItem?.saleLabel) === "ctn"
                    ? "Box Per Ctn"
                    : "Pieces Per Box"
                }
                type="Number"
                value={state.editItem.piecesPerBox}
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
            <Input>
              <TextField
                variant="standard"
                min="1"
                label={
                  state.editItem.box == true &&
                  (state?.editItem?.saleLabel || editItem?.saleLabel) === "ctn"
                    ? "Price Per Box"
                    : "Price Per Piece"
                }
                name="pricePerPiece"
                value={pricePerBoxHandler() || state.editItem.pricePerPiece}
                type="number"
                fullWidth
                InputProps={{ disableUnderline: true }}
                onChange={handleInput}
              />
            </Input>
          </Stack>
        )}
        {state?.editItem?.box == true && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Select Sale Label</InputLabel>
              <Select
                variant="standard"
                name="saleLabel"
                value={state?.editItem?.saleLabel || editItem.saleLabel}
                onChange={handleInput}
                // value={newItem.vendor}
              >
                <MenuItem value="ctn">Ctn</MenuItem>
                <MenuItem value="box">Box</MenuItem>
              </Select>
            </FormControl>
          </Input>
        )}
        {!itemNewDesign() && (
          <Input>
            <FormControl style={{ width: "100%" }}>
              <InputLabel>Vendors</InputLabel>
              <Select
                variant="standard"
                name="vendor"
                onChange={handleInput}
                value={state.editItem.vendor}
              >
                {vendor?.vendors.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item.companyName}>
                      {item.companyName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Input>
        )}

        <Box>
          <Typography sx={{ textAlign: "left" }}>Expiry Date</Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            name="expiryDate"
            variant="outlined"
            value={state?.editItem?.expiryDate || editItem?.expiryDate}
            onChange={handleInput}
          />
        </Box>
        {!itemNewDesign() && (
          <Stack direction="row" width="100%" justifyContent="space-between">
            {/* <FormControl style={{ width: "100%" }}>
            <InputLabel>Batch Numbers</InputLabel>
            <Select variant="outlined" label="Batch Numbers" defaultValue="">
              <MenuItem value="">Select Batch Number</MenuItem>
              {state.editItem?.batchNumber.map((item, i) => {
                return (
                  <MenuItem key={i} value={item.batchNumber}>
                    <Box>
                      <Stack
                        direction="row"
                        width="100%"
                        justifyContent="space-between"
                      >
                        <Typography>Batch No. {item.batchNumber}</Typography>
                        <Typography>Quantity {item.quantity}</Typography>
                      </Stack>
                      <Typography>Expiry Date {item.expiryDate}</Typography>
                    </Box>
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl> */}
            <Box>
              <Button
                size="small"
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={() => toggle("allBatchModal")}
              >
                Batch Numbers
              </Button>
            </Box>
            <Box>
              <Button
                size="small"
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={() => toggle("batchModal")}
              >
                Add Batch No.
              </Button>
            </Box>
          </Stack>
        )}
        {!itemNewDesign() && (
          <Button
            size="small"
            onClick={() => toggle("vendorModal")}
            style={{ color: "#4EAF51" }}
          >
            Add Items Brands
          </Button>
        )}

        {itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              name="country"
              label="Country"
              type="text"
              fullWidth
              InputProps={{ disableUnderline: true }}
              value={state.editItem.country || editItem?.country || ""}
              onChange={handleInput}
            />
          </Input>
        )}
        {itemNewDesign() && (
          <Input>
            <TextField
              variant="standard"
              name="location"
              label="Location"
              type="text"
              fullWidth
              InputProps={{ disableUnderline: true }}
              value={state.editItem.location || editItem?.location || ""}
              onChange={handleInput}
            />
          </Input>
        )}
      </Stack>

      {IncentivesFeature() && <Incentives item={editItem} />}

      <Stack
        direction="row"
        justifyContent="space-evenly"
        spacing={5}
        marginTop={2}
      >
        <Button
          fullWidth
          sx={{
            background: "#ff0000 !important",
            color: "#ffff",
          }}
          onClick={() => toggle("deleteModal")}
        >
          Delete
        </Button>
        <Button fullWidth variant="contained" onClick={handleUpdate}>
          Update
        </Button>
        <Button fullWidth variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </Stack>

      <DialogComponent
        title={companyCode == "8553" ? "Add Size" : " Add Unit"}
        onClose={() => toggle("unitsModal")}
        open={state.unitsModal}
        dialogContent={<AddUnit onClose={() => toggle("unitsModal")} />}
      />
      <DialogComponent
        title={companyCode == "8553" ? "Show Sizes" : " Show Units"}
        onClose={() => toggle("showUnits")}
        open={state.showUnits}
        dialogContent={<UnitsList onClose={() => toggle("showUnits")} />}
      />
      <DialogComponent
        title="Add Items Brands"
        onClose={() => toggle("vendorModal")}
        open={state.vendorModal}
        dialogContent={<AddVendor onClose={() => toggle("vendorModal")} />}
      />
      <DeleteDialog
        title="Delete Item"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={handleDelete}
      />
      {state.batchModal && (
        <AddBatchNo
          onClose={() => toggle("batchModal")}
          onSuccess={(e) => handleBatch(e)}
        />
      )}
      {state.allBatchModal && (
        <ShowBatchNos
          onClose={() => toggle("allBatchModal")}
          items={state?.editItem?.batchNumber || []}
          onSuccess={(e) => handleUpdateBatch(e)}
        />
      )}
    </Box>
  );
}

export default UpdateItem;
